import { Button, Stack, Typography } from "@mui/material";
import Iconify from "../../../components/Iconify";
import React, { useState } from "react";
import FrmAgregarPersona from "./Forms/FrmAgregarPersona";
const AddPersonaButtom = ({
  setOpenDialog,
  setBodyDialog,
  setOpenSnackBar,
  setErrorGraph,
}) => {
  //Abrir el dialog
  const handleOpenDialog = () => {
    setBodyDialog(
      <FrmAgregarPersona
        setOpenDialog={setOpenDialog}
        setErrorGraph={setErrorGraph}
        setOpenSnackBar={setOpenSnackBar}
      />
    );
    setOpenDialog(true);
  };
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={5}
    >
      <Typography variant="h4" gutterBottom>
        Catálogo de Personas
      </Typography>
      <Button
        onClick={() => handleOpenDialog()}
        startIcon={<Iconify icon="eva:plus-fill" />}
      >
        Nuevo registro
      </Button>
    </Stack>
  );
};

export default AddPersonaButtom;
